import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getProductFull } from '../Api'

export default generateApiAction({
  baseType: Types.PRODUCTS.GET.FULL,
  api: getProductFull,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/products/GetFullAction.js